import { useState } from "react";
import { Send, Loader2, Megaphone } from "lucide-react";
import { toast } from "@/components/ui/sonner";
import { broadcastPush } from "@/lib/api";

const input = "w-full rounded-xl border border-gray-200 px-4 h-11 text-sm outline-none focus:ring-2 focus:ring-brand-yellow/60";

// Admin: broadcast a Web Push announcement to every subscribed member.
export default function PushBroadcastCard() {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    if (!title.trim() || !body.trim()) {
      toast.error("Title and message are required.");
      return;
    }
    if (!window.confirm("Send this notification to everyone who allowed notifications?")) return;
    setBusy(true);
    try {
      const r = await broadcastPush({ title: title.trim(), body: body.trim(), url: url.trim() || undefined });
      toast.success(`Sent to ${r.sent}/${r.recipients} device${r.recipients === 1 ? "" : "s"}.`);
      setTitle(""); setBody(""); setUrl("");
    } catch (e) {
      toast.error(e.message || "Broadcast failed.");
    }
    setBusy(false);
  };

  return (
    <div className="rounded-2xl border border-gray-200 bg-white shadow-sm p-5" data-testid="push-broadcast-card">
      <h3 className="flex items-center gap-2 text-sm font-bold uppercase tracking-[0.1em] text-gray-900">
        <Megaphone className="h-4 w-4 text-brand-orange" /> 📣 Send Push Notification
      </h3>
      <p className="mt-2 text-xs text-gray-500">
        Blast an announcement (new feature, update, deal) to every member who allowed notifications. Leave the link blank to open the app home.
      </p>
      <div className="mt-3 space-y-2.5">
        <input data-testid="push-title-input" className={input} placeholder="Title — e.g. New Feature!" maxLength={120} value={title} onChange={(e) => setTitle(e.target.value)} />
        <textarea data-testid="push-body-input" className={`${input} h-auto py-2.5`} rows={2} placeholder="Message — e.g. We just added flight price alerts. Check it out!" maxLength={400} value={body} onChange={(e) => setBody(e.target.value)} />
        <input data-testid="push-url-input" className={input} placeholder="Optional link (defaults to app home)" maxLength={500} value={url} onChange={(e) => setUrl(e.target.value)} />
      </div>
      <button
        onClick={send}
        disabled={busy}
        data-testid="push-send-btn"
        className="mt-3 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-brand-yellow to-brand-orange px-5 h-10 text-sm font-bold uppercase tracking-[0.06em] text-black transition-transform hover:scale-105 disabled:opacity-60"
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Send to All
      </button>
    </div>
  );
}
